
import Defs from './../../../../../zviz2/zviz/components/svg/defs';
import ClipPath from './../../../../../zviz2/zviz/components/svg/clippath';
import Gradient from './../../../../../zviz2/zviz/components/svg/lineargradient';
import Stop from './../../../../../zviz2/zviz/components/svg/stop';
import Rectangle from './../../../../../zviz2/zviz/components/rectangle';
import state from './../../../../../zviz2/zviz/state';

import GeoModel from './../model/geo';

import {extend, cloneObject} from './../../../../../zviz2/zviz/functions';



let Blueprint = extend({
    properties: { 
        data: {
            width: 500,
            height: 200,
            countryColor: [180,180,180],
            highlightColor: [220,180,180],
        }
    },
    children: [ 
        (parent) => (extend({
            properties:{
                attributes: {
                    'id': 'mapGradient',
                    'x1': (ctrl) => (ctrl.models['geo'].boundingBox[0].x),
                    'y1': (ctrl) => (ctrl.models['geo'].boundingBox[0].y),
                    'x2': (ctrl) => (ctrl.models['geo'].boundingBox[0].x),
                    'y2': (ctrl) => (ctrl.models['geo'].boundingBox[1].y)
                }
            },
            models: {
                'geo': null
            },
            listeners: [
                (ctrl) => ( ctrl.addListener(ctrl.models['geo']) ),
            ],
            children: [
                extend({
                    properties: {
                        attributes: { 'offset': '0' },
                        style: { 
                            stopColor: 'rgb(' + parent.data.countryColor.slice(0,3).join(',') + ')',
                            stopOpacity: '0'
                        }
                    }

                }, Stop),

                extend({
                    properties: {
                        attributes: { 'offset': '0.2' },
                        style: { 
                            stopColor: 'rgb(' + parent.data.countryColor.slice(0,3).join(',') + ')',
                            stopOpacity: ( parent.data.countryColor.length > 3? parent.data.countryColor[3]: 1 )
                        }
                    }

                }, Stop)

            ]
        }, Gradient) ),

        (parent) => (extend({
            properties:{
                attributes: {
                    'id': 'mapGradientHighlight',
                    'x1': (ctrl) => (ctrl.models['geo'].boundingBox[0].x),
                    'y1': (ctrl) => (ctrl.models['geo'].boundingBox[0].y),
                    'x2': (ctrl) => (ctrl.models['geo'].boundingBox[0].x),
                    'y2': (ctrl) => (ctrl.models['geo'].boundingBox[1].y)
                }
            },
            models: {
                'geo': null
            },
            listeners: [
                (ctrl) => ( ctrl.addListener(ctrl.models['geo']) ),
            ],
            children: [
                extend({
                    properties: {
                        attributes: { 'offset': '0' },
                        style: { 
                            stopColor: 'rgb(' + parent.data.highlightColor.slice(0,3).join(',') + ')',
                            stopOpacity: '0'
                        }
                    }

                }, Stop),

                extend({
                    properties: {
                        attributes: { 'offset': '0.2' },
                        style: { 
                            stopColor: 'rgb(' + parent.data.highlightColor.slice(0,3).join(',') + ')',
                            stopOpacity: ( parent.data.highlightColor.length > 3? parent.data.highlightColor[3]: 1 )
                        }
                    }

                }, Stop)

            ]
        }, Gradient) ),

        (parent) => (extend({
            properties:{
                attributes: {
                    'id': 'mapBgGradient',
                    'x1': 0,
                    'y1': 0,
                    'x2': 0,
                    'y2': parent.data.height
                }
            },
            children: [
                extend({
                    properties: {
                        attributes: { 'offset': '0.3' },
                        style: { 
                            stopColor: 'rgb(229,240,249)'
                        }
                    }

                }, Stop),

                extend({
                    properties: {
                        attributes: { 'offset': '1' },
                        style: { 
                            stopColor: 'rgb(255,251,246)'
                        }
                    }

                }, Stop)

            ]
        }, Gradient) ),

        (parent) => (extend({
            properties: {
                attributes: {
                    'id': 'mapClipPath',
                    'clipPathUnits': 'userSpaceOnUse'
                },
                data: { width: parent.data.width, height: parent.data.height }
            },
            children: [
                extend({
                    properties: {
                        attributes: {
                            'x': '0', 
                            'y': '0', 
                            'width': parent.data.width,
                            'height': parent.data.height
                        }
                    }
                }, Rectangle)
            ]
        }, ClipPath) ),

    ]
}, Defs);

export default Blueprint;